import { Modal } from 'antd';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import { AppStore, CurrentUserStore } from 'stores';
import OktaAuthService from '../../v3/components/forms/auth/OktaAuthService';

const LogoutModal = ({ history }) => {
  const modalBody = <p>Are you sure you want to logout?</p>;

  const handleSubmit = async (e) => {
    e.preventDefault();
    AppStore.showLogoutModal.set(false);
    CurrentUserStore.logout();
    await OktaAuthService.signOut();
    history.push('/login');
    window.location.reload();
  };

  const handleCancel = () => {
    AppStore.showLogoutModal.set(false);
  };

  return (
    <Modal
      title="Logout"
      centered
      open={AppStore.showLogoutModal.get()}
      okText="Logout"
      onCancel={handleCancel}
      onOk={handleSubmit}
    >
      {modalBody}
    </Modal>
  );
};

LogoutModal.propTypes = {
  history: PropTypes.object,
};

export default withRouter(observer(LogoutModal));
